




















import { Vue, Component, Prop, Model, Emit } from 'vue-property-decorator';
import { getRgTagList } from '@/api/cti';

interface TagOption {
    id: number;
    name: string;
}

@Component
export default class TagFilter extends Vue {
    @Model('change', { type: Array, default: () => [] })
    readonly value!: number[];

    options: TagOption[] = [];

    @Prop({ type: Number, default: 0 })
    readonly rgId!: number;

    searching: boolean = false;

    get selectedValue(): number[] {
        return this.value;
    }

    set selectedValue(newValue: number[]) {
        this.$emit('change', newValue);
    }

    @Emit('change')
    handleChange(value: number[]) {
        return value;
    }

    async remoteSearch(query: string) {
        if (!query) {
            this.$emit('remote-search', '');
            return;
        }

        this.searching = true;
        try {
            const res = await getRgTagList({
                name: query
            });

            if (res.code === 200 && res.data && res.data.items) {
                this.options = res.data.items;
            }
        } catch (error) {
            console.error('搜索标签异常:', error);
            this.$emit('remote-search', []);
        } finally {
            this.searching = false;
        }
    }
}
